// Tipe adjustment ROB & bunkering. Sengaja NOL IMPORT biar bisa dijalanin pakai node.

export const ADJUSTMENT_TYPE_RESET = 1;
export const ADJUSTMENT_TYPE_ADJUST = 2;

// Dipakai langsung sebagai :options b-form-select.
export const ADJUSTMENT_TYPE_OPTIONS = [
  { value: ADJUSTMENT_TYPE_RESET, text: 'Reset Value' },
  { value: ADJUSTMENT_TYPE_ADJUST, text: 'Adjust Value' },
];

// Number() dipakai karena backend kadang ngirim tipe sebagai string.
export function adjustmentTypeLabel(type) {
  return Number(type) === ADJUSTMENT_TYPE_RESET ? 'Reset Value' : 'Adjust Value';
}
